import React from 'react';
import { Term } from '@benzinga/content-manager';
import styled from '@benzinga/themetron';
import { sanitizeHTML } from '@benzinga/frontend-utils';

export interface PostedInProps {
  terms: Term[];
  variant?: 'default' | 'secondary';
}

export const PostedIn = ({ terms, variant = 'default' }: PostedInProps) => {
  if (!Array.isArray(terms) || (Array.isArray(terms) && !terms.length)) return null;
  return (
    <Container className="article-taxonomy" variant={variant}>
      {variant === 'default' && <strong className="mr-2">Posted In: </strong>}
      <div className="posted-in-list">
        {terms.map((term: Term) => {
          if (!term) return null;
          return (
            <PostedInLink
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(term.name) }}
              href={term.url_public ? `/${term.url_public}` : `/taxonomy/term/${term.tid}`}
              key={term.tid}
              variant={variant}
            />
          );
        })}
      </div>
    </Container>
  );
};

const Container = styled.div<{ variant: 'default' | 'secondary' }>`
  &.article-taxonomy {
    font-size: ${({ variant }) => (variant === 'default' ? '12px' : '16px')};
    line-height: 12px;
    margin-bottom: 26px;
    white-space: nowrap;

    a {
      text-decoration: none;
    }

    .posted-in-list {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
    }
  }
`;

const PostedInLink = styled.a<{ variant: 'default' | 'secondary' }>`
  background: ${({ variant }) => (variant === 'default' ? '#f5f5f5' : 'rgba(63, 131, 248, 0.05)')};
  border-radius: ${({ variant }) => (variant === 'default' ? 'initial' : '8px')};
  border: 1px solid #ddd;
  display: inline-block;
  padding: ${({ variant }) => (variant === 'default' ? '4px 8px 4px 8px;' : '8px 8px 8px 8px;')};

  :hover {
    text-decoration: underline;
  }
`;
